import { RequestUnsuccessComponent } from '../request-unsuccess/request-unsuccess.component';
import { BillingCommentComponent } from '../../billing-comment/billing-comment-successful/billing-comment.component';
import { MapfreModalComponent } from '../../../../../../modules/mapfre-design-library/src/lib/_components/section-components/mapfre-modal/mapfre-modal.component';
import { MapfreButtonComponent } from '../../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { BillingHeaderComponent } from '../../billing-header/billing-header.component';
import { MapfreCardComponent } from '../../../../../../modules/mapfre-design-library/src/lib/_components/wrapper-components/mapfre-card/mapfre-card.component';
import { MapfreLoadingComponent } from '../../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/mapfre-loading/mapfre-loading.component';
import { MdbFormsModule } from 'mdb-angular-ui-kit/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators , FormsModule , ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Params, Router , RouterModule } from '@angular/router';
import { ModalOptions, FormBaseControlService } from '@mapfre-design-library/src/public_api';
import { BillingDetailsService } from '@services/my-insurance/billing-details.service';
import { StorageServiceObservablesService } from '@services/storage-service-observables/storage-service-observables.service';
import { SelfRequestFormService } from '@services/forms/self-request-form/self-request-form.service';
import { BillingRequestService } from '@services/billing-request.service';
import { PolicyDataService } from '../../../../../../_services/data-services/policy-data.service';
import { Topic } from '@models/topic';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MdbFormsModule, MapfreLoadingComponent, MapfreCardComponent, BillingHeaderComponent, MapfreButtonComponent, MapfreModalComponent, BillingCommentComponent, RequestUnsuccessComponent],
  selector: 'app-other-request',
  templateUrl: './other-request.component.html',
  styleUrls: ['./other-request.component.scss'],
  providers: [FormBaseControlService],
})
export class OtherRequestComponent implements OnInit {
  policy: any ;
  requestType: string;
  sendRequestModal: ModalOptions;
  requestFormGroup: FormGroup;
  loading: boolean;
  hideModal: boolean;
  policyTypeImg: string;
  policyType: string;
  otherPolicies: any;
  inputs: any[];
  topicOptions: Topic[];
  showSuccessModal: boolean;
  showFailureModal: boolean;

  constructor(
    private selfRequestForm: SelfRequestFormService,
    private ipt: FormBaseControlService,
    private storageObservable: StorageServiceObservablesService,
    private billingDetailsService: BillingDetailsService,
    private router: Router,
    private billingRequestService: BillingRequestService,
    private policyDataService: PolicyDataService,
    private activatedRoute: ActivatedRoute
  ) {
    
   }
  setModal() {
    this.sendRequestModal = new ModalOptions({
      additionalClasses:
      `billing-quetion-modal modal-medium modal-dialog center-on-page center-modal modal-dialog-scrollable`,
      additionalButtonClasses: "request fs-16 other-request-type",
      buttonCopy: this.requestType,
      modalId: 'sendRequest',
      modalName: 'other_request',
      onLoad : true
    });
  }

  setPolicyTypeImage(){
    this.policyType = this.policy?.policyType;
    this.policyTypeImg = this.billingRequestService.setPolicyTypeImage(this.policyType);
  }

  setOtherPolicies(){
    this.policyDataService.$policyDetails.subscribe((policyResponse) => {
      if (policyResponse && policyResponse.length > 1) {
        this.otherPolicies = policyResponse.filter(
            (policyRes) => policyRes.policynumber.policyNumber !== this.policy?.policynumber.policyNumber
          )
          .map(
            (policyRes) => {
                let sys = 'Guidewire';
                if (policyRes.company?.companyName == 'TW') {
                  sys = 'TW'
                } else if (policyRes.company?.companyName == 'ACIC') {
                  sys = 'V12'
                } else if (policyRes.policynumber?.policyNumber?.length == 6) {
                  sys = 'AS400'
                }
               return sys + ' - ' + (policyRes.displayType?.label?.toUpperCase() ?? policyRes.policyType)
                         + ' - ' + policyRes.policynumber?.policyNumber; 
            }
          );
      }       
    });
  }

  unhideModal(){
    this.hideModal = false;
  }

  resetForm(){
    this.requestFormGroup.controls.otherRequest_topic.setValue(null);
    this.requestFormGroup.controls.addInfo.reset();
    
  }

  resetHideModal(event): void {
    if (event) {
      this.hideModal = !this.hideModal;
      this.showSuccessModal=false;
      this.showFailureModal=false;
    }
  }

  onMessageTopicChange() {
    if(this.requestFormGroup.controls.otherRequest_topic.value === "Cancellations"){
      this.router.navigate(
          ['/my-insurance', this.policy?.policynumber?.policyNumber, 'self-request', 'cancellations']
        );
      return;
    }
  }

  sendRequest(){
    const subTopic = this.requestFormGroup.controls.otherRequest_topic.value;   
    const insured = this.policy.insured.find(insured => insured.isPrimaryInsured)
    const requestPayload = {
      policyNumber: this.policy.policynumber.policyNumber,
      policyType: this.policy?.displayType?.label?.toUpperCase() ?? this.policy?.policyType,
      isPaperless: this.policy.policyFlags.isEdf === 'ENROLLED' ? 'Yes' : 'No',
      isAutoPay: this.policy.policyFlags.isEft === 'ENROLLED' ? 'Yes' : 'No',
      otherPolicies: this.otherPolicies,
      firstName: insured.firstName,
      lastName: insured.lastName,
      inquiryDate: new Date().toLocaleDateString(),
      inquiryTime: new Date().toLocaleTimeString(),
      inquiryTopic: this.requestType,
      inquiry: this.requestFormGroup.controls.addInfo.value,
      email: this.storageObservable.getUserFromStorage(),
      addProperties: {inquirySubTopic: subTopic},
      isSelfCustomerRequest: true
    };
    this.submitRequest(requestPayload);
    this.resetForm();
    
  }
  submitRequest(payload: any){
    this.loading = true;
    this.billingDetailsService.sendBillingQuestion(
        payload,
        this.storageObservable.getUserFromStorage()
      )
      .subscribe(
        () => {
          this.router.navigate(['/my-insurance', this.policy.policynumber.policyNumber, 'other-request-success']);
          this.showFailureModal = false;
          this.loading = false;
        },
        () => {
          this.showFailureModal = true;
          this.showSuccessModal = false;
          this.loading = false;
        }
      );
  }

  tryAgain(event: boolean){
    this.showFailureModal = false;
    if(!event){
      this.router.navigate(['/my-insurance', this.policy?.policynumber?.policyNumber, 'billing']);
    }
  }
  clearForm() {
    this.requestFormGroup = new FormGroup({
      otherRequest_topic: new FormControl(null, Validators.required),
      addInfo: new FormControl('', Validators.required)
    });
  }
  
  ngOnInit(): void {
    this.requestType = "Other request";
    
    this.activatedRoute.params.subscribe((params: Params) => {
      const policyId = params['policyid'];
      this.policyDataService.$policyDetails.subscribe((policyResponse) => {
        if (policyResponse) {
          this.policy = policyResponse
            .find(policyDetails => policyDetails.policynumber.policyNumber === policyId);
          this.loading = false;
        }
      });
    });
    this.clearForm();
    this.setModal();
    this.setPolicyTypeImage();
    this.setOtherPolicies();
    this.setDynamicTopic(this.policy);
    // this.requestFormGroup = this.ipt.toFormGroup(this.inputs);
  };
  setDynamicTopic(selectedPolicy) {
    if (selectedPolicy) {
      const { jurisdiction,policynumber } = selectedPolicy;
      if ( jurisdiction.state === 'MA' && policynumber.policyNumber.length === 10) {
        this.topicOptions = this.selfRequestForm.getOtherRequestTopicMAGWLists();
      }else{
        this.topicOptions = this.selfRequestForm.getOtherRequestTopicNonMAGwLists();
      }
    }
  }
}
